<template><div class="unit-files">
  <loading v-if="apiref" />
  <div v-if="unit && next_run !== false">
    <span v-if="!downloadImminent">
      Next file acquisition will occur
      {{ next_run.from(now) }} if the unit is on-line.
    </span>
    <span v-else-if="!unit.online">
      Next file acquisition will occur when the unit comes back on-line.
    </span>
    <span v-else>
      Next file acquisition will occur any moment now.
    </span>
    <button v-if="!downloadImminent" @click="triggerDownload">Download now</button>
  </div>
  <table v-if="files.length" class="selectable">
  <tr>
    <th>Acquired</th>
    <th>Type</th>
    <th>Download</th>
  </tr>
  <tr v-for="f in files" :key="`file-${f.url}`">
    <td v-html="f.acquired.format('MMMM D, YYYY HH:mm:ss')" />
    <td v-html="typeName(f.type)" />
    <td><a :href="f.url">Download</a></td>
  </tr>
  </table>
  <div v-else-if="apiref">
    Loading...
  </div>
  <div v-else>
    There are no files available for this unit.
  </div>
  <button @click="loadMore" v-if="again">Load more...</button>
</div></template>
<script>
import api from '../api'
import Loading from './Loading'
export default {
  name: 'unit-files',
  components: { Loading },
  data() {
    return {
      files: [],
      error: false,
      apiref: null,
      again: true,
      next_run: false,
      timeout: null,
      now: moment(),
      interval: null,
    }
  },
  computed: {
    id() { return this.$store.state.selectedUnit },
    unit() { return this.$store.state.units[this.id] },
    downloadImminent() { return !moment.isMoment(this.next_run) || this.next_run.diff(this.now, 'seconds') < 10 },
  },
  watch: {
    id() {
      this.files = []
      this.loadMore()
    },
    'unit.online': function(nv, ov) {
      this.setTimer()
    },
  },
  mounted() {
    this.loadMore()
    this.setTimer()
    this.interval = setInterval(() => { this.now = moment() }, 1000)
  },
  destroyed() {
    this.clearTimer()
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  },
  methods: {
    setTimer() {

      // Clear any existing timer.
      this.clearTimer()

      // No point in refreshing if the unit is offline.
      if (!this.unit || !this.unit.online)
        return

      // Unit is on-line; calculate amount of time to wait.
      let delay
      if (moment.isMoment(this.next_run)) {
        delay = this.next_run.diff(moment())    // how long until next download?
        if (delay < -120000) delay = 60000      // more than 2m in the past. check every 1m
        else if (delay < 10000) delay = 10000   // download is imminent. check every 10s
        else if (delay > 600000) delay = 600000 // more than 10m in the future. check every 10m
        // else: between 10s and 10min in the future. wait exactly that amount of time.
      } else {
        delay = 60000 // download is imminent; check once pre minute.
      }

      // Schedule the update.
      this.timeout = setTimeout(this.loadNew, delay)

    },
    clearTimer() {
      if (this.timeout !== null) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
    },
    async loadMore() {
      if (this.id === null) return
      if (this.apiref) {
        this.apiref.cancel()
      }
      try {
        let ref = this.apiref = { uid: this.id }
        if (this.files.length) {
          ref.before = this.files[this.files.length-1].acquired
        }
        let rv = await api.unitFiles(ref)
        if (rv.files.length)
          this.files.splice(this.files.length, 0, ...rv.files)
        this.again = rv.again
        this.next_run = rv.next_run
      } catch(e) {
        if (!(e instanceof api.Canceled))
          console.error(e)
      } finally {
        this.apiref = null
      }
      this.setTimer()
    },
    async loadNew() {
      if (this.id === null) return
      if (!this.files.length)
        return this.loadMore()
      if (this.apiref) {
        this.apiref.cancel()
      }
      let rv = null
      try {
        let ref = this.apiref = { uid: this.id, after: this.files[0].acquired }
        rv = await api.unitFiles(ref)
        for (let f of rv.files)
          this.files.unshift(f)
        this.next_run = rv.next_run
      } catch(e) {
        if (!(e instanceof api.Canceled))
          console.error(e)
      } finally {
        this.apiref = null
      }
      if (rv && rv.again)
        await this.loadNew()
      this.setTimer()
    },
    typeName(type) {
      switch (type) {
      case 'tfl': return 'Fault Log'
      case 'tdr': return 'Data Recorder Log'
      case 'trig.trt': return 'Trigger Log'
      default: return type
      }
    },
    async triggerDownload() {
      await api.triggerDownload({ uid: this.id })
      await this.loadNew()
    },
  },
}
</script>
<style lang="scss" scoped>
.unit-files {
  padding: 20px;
  table {
    border-collapse: collapse;
    margin: 10px 0;
  }
  th, td {
    border: 1px solid #000;
    padding: 5px 10px;
  }
  .loading {
    position: fixed;
    top: 100px;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100px;
    height: 100px;
  }
}
</style>
